export var SiteSettingsFieldset;
(function (SiteSettingsFieldset) {
    SiteSettingsFieldset[SiteSettingsFieldset["EVENTS_SUMMARY"] = 0] = "EVENTS_SUMMARY";
})(SiteSettingsFieldset || (SiteSettingsFieldset = {}));
export var ComponentFieldset;
(function (ComponentFieldset) {
    ComponentFieldset[ComponentFieldset["SITE_SETTINGS"] = 0] = "SITE_SETTINGS";
    ComponentFieldset[ComponentFieldset["DRAFT"] = 1] = "DRAFT";
    ComponentFieldset[ComponentFieldset["EVENTS"] = 2] = "EVENTS";
})(ComponentFieldset || (ComponentFieldset = {}));
export var StatusFilter;
(function (StatusFilter) {
    StatusFilter[StatusFilter["FUTURE_AND_PAST"] = 0] = "FUTURE_AND_PAST";
    StatusFilter[StatusFilter["FUTURE_ONLY"] = 1] = "FUTURE_ONLY";
    StatusFilter[StatusFilter["PAST_ONLY"] = 2] = "PAST_ONLY";
})(StatusFilter || (StatusFilter = {}));
//# sourceMappingURL=editor.js.map